<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.editPartner')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.editPartner')}}</div>
                            <b-button type="submit" variant="primary" class="float-right"
                                :disabled="disableEditForm || !permissions.editSettingsPartners">{{$t('button.save')}}
                            </b-button>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label>{{$t('form.setting.partnerCode')}}</label>
                                <input type="text" class="form-control" v-model="partner.PartnerCode" disabled>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.partnerName')}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="partner.PartnerName" required>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.country')}}<span class="text-danger">*</span></label>
                                <v-select label="printable_name" :options="countries" v-model="partner.PartnerCountry"
                                    :reduce="countries => countries.printable_name" :key="partner.PartnerCountry">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search" :required="!partner.PartnerCountry"
                                            v-bind="attributes" v-on="events" />
                                    </template>
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.mainCampus')}}<span class="text-danger">*</span></label>
                                <v-select label="PartnerCampusLocation" :options="campuses"
                                    :key="partner.PartnerMainCampus" v-model="partner.PartnerMainCampus"
                                    :reduce="campuses => campuses.PartnerCampusID">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search" :required="!partner.PartnerMainCampus"
                                            v-bind="attributes" v-on="events" />
                                    </template>
                                </v-select>
                            </div>


                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="partner.PartnerOverrideCampus">
                                    {{$t('form.setting.overrideCampus')}}
                                </label>
                            </div>



                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="partner.PartnerOverrideCountry">
                                    {{$t('form.setting.overrideCampusPartnerCountry')}}
                                </label>
                            </div>


                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="partner.OverridePlaceSBS">
                                    {{$t('form.setting.overrideWithSBS')}}
                                </label>
                            </div>

                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="partner.PartnerActive">
                                    {{$t('form.setting.active')}}
                                </label>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.sortOrder')}}</label>
                                <input type="number" class="form-control" v-model="partner.PartnerSortOrder">
                            </div>

                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'editFormInterval'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                partner: {
                    PartnerCode: null,
                    PartnerName: null,
                    PartnerCountry: null,
                    PartnerMainCampus: null,
                    PartnerOverrideCampus: null,
                    PartnerActive: null,
                    PartnerSortOrder: null,
                    OverridePlaceSBS: null,
                    PartnerOverrideCountry:false,

                },

                countries: [],
                campuses: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsPartners) {
                return this.$router.push('/');
            }

            if (this.permissions.editSettingsPartners) {
                this.checkForEdit();
                  this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.initialData();
            this.fetch();
        },

        watch: {
            partner: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            initialData() {
                axios
                    .get(`/api/partners/initial-data?id=${this.$route.params.id}`)
                    .then(response => {
                        this.countries = response.data.countries;
                        this.campuses = response.data.campuses;
                    })
                    .catch(error => console.log('error fetching initial data'));
            },


            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                  this.fetch();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },



            fetch() {
                this.isLoading = true;

                axios
                    .get(`/api/partners/${this.$route.params.id}/edit`)
                    .then(response => {
                        if (response.data.success) {
                            this.partner = response.data.data;
                        }

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 1000);
                    })
                    .catch(error => {
                        console.log('error fetching partner record');
                        this.isLoading = false;
                    });
            },

            submit() {

                if (this.disableEditForm) return;

                if (!this.partner.PartnerName ||
                    !this.partner.PartnerCountry ||
                    !this.partner.PartnerMainCampus) {
                    return this.showAlert(this.$t('form.validation.error'), 'danger');
                }

                this.clearAlert();

                this.isLoading = true;

                axios
                    .put(`/api/partners/${this.$route.params.id}`, this.partner)
                    .then(response => {

                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'PartnerIndex'
                                });
                            }, 2000);
                        }

                    }).catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, 'danger');
                    })
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            clearAlert() {
                this.alert = false;
                this.alertClass = '';
                this.alertMessage = '';
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    }

</script>
